// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Atom_Box = require("../atom/Atom_Box.bs.js");
var Atom_Cta = require("../atom/Atom_Cta.bs.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Atom_Cell = require("../atom/Atom_Cell.bs.js");
var UseOnBlur = require("../../hook/UseOnBlur.bs.js");
var UseToggle = require("../../hook/UseToggle.bs.js");
var Util_I18n = require("../../util/Util_I18n.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Caml_array = require("@rescript/std/lib/js/caml_array.js");
var Atom_Column = require("../atom/Atom_Column.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var UseClickOutside = require("../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Organism_Header_Css = require("../organism/header/Organism_Header_Css.bs.js");
var Particle_Accessibility = require("../particle/Particle_Accessibility.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Organism_HeaderAccessibility = require("../organism/header/Organism_HeaderAccessibility.bs.js");

function Molecule_LanguageSwitcher$Item(Props) {
  var languageSwitcherBehavior = Props.languageSwitcherBehavior;
  var languageItem = Props.languageItem;
  var alternativeLanguages = Props.alternativeLanguages;
  var activeLanguage = Props.activeLanguage;
  var close = Props.close;
  var language = languageItem.language;
  var label = languageItem.label;
  var acronym = languageItem.acronym;
  var currentAlternativeLanguage = Belt_Option.flatMap(alternativeLanguages, (function (param) {
          return Js_array.find((function (alternativeLanguage) {
                        return language === alternativeLanguage.code;
                      }), param);
        }));
  var alternativeHref = currentAlternativeLanguage !== undefined ? currentAlternativeLanguage.url : languageItem.href;
  var isCurrent = activeLanguage.acronym === acronym;
  var accessibility = Particle_Accessibility.make(undefined, undefined, isCurrent, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, acronym, undefined, undefined, undefined);
  if (!languageSwitcherBehavior) {
    return React.createElement(Atom_Cta.Link.make, {
                accessibility: accessibility,
                href: alternativeHref,
                label: label + (" (" + (acronym + ")")),
                style: {
                  TAG: /* Header */10,
                  _0: {
                    TAG: /* LanguageSwitcherItem */6,
                    _0: isCurrent ? /* Active */({
                          _0: undefined
                        }) : /* Inactive */0
                  }
                }
              });
  }
  var changeLanguageHandler = languageSwitcherBehavior._0;
  var handleClick = function (param) {
    Curry._1(changeLanguageHandler, language);
    Curry._1(close, undefined);
  };
  return React.createElement(Atom_Cta.Button.make, {
              accessibility: accessibility,
              label: label + (" (" + (acronym + ")")),
              onClick: handleClick,
              style: {
                TAG: /* Header */10,
                _0: {
                  TAG: /* LanguageSwitcherItem */6,
                  _0: isCurrent ? /* Active */({
                        _0: undefined
                      }) : /* Inactive */0
                }
              }
            });
}

var Item = {
  make: Molecule_LanguageSwitcher$Item
};

function Molecule_LanguageSwitcher(Props) {
  var locale = Props.locale;
  var labels = Props.labels;
  var searchState = Props.searchState;
  var modeOpt = Props.mode;
  var alternativeLanguages = Props.alternativeLanguages;
  var languageSwitcherBehavior = Props.languageSwitcherBehavior;
  var ffNewConcertHeader = Props.ffNewConcertHeader;
  var mode = modeOpt !== undefined ? modeOpt : "replay";
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match.close;
  var state = match.state;
  var toggle = match.toggle;
  var ref = React.useRef(null);
  UseClickOutside.make(ref, close);
  UseOnBlur.make(ref, close);
  var displayLanguagesPanel = state ? CssJs.none : CssJs.flexBox;
  var display = Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, searchState ? "flex" : "none");
  var activeLanguage = Belt_Option.getWithDefault(Belt_Array.getBy(labels.languages, (function (language) {
              return Util_I18n.localeToString(locale) === language.language;
            })), Caml_array.get(labels.languages, 0));
  var languagesPanel = React.createElement(Atom_Column.make, {
        alignItems: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "stretch"),
        background: Particle_Background_Ds.dropdownMenu,
        blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("None")),
        children: Belt_Array.map(labels.languages, (function (language) {
                return React.createElement(Atom_Cell.make, {
                            display: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex),
                            kind: /* ItemList */4,
                            children: React.createElement(Molecule_LanguageSwitcher$Item, {
                                  languageSwitcherBehavior: languageSwitcherBehavior,
                                  languageItem: language,
                                  alternativeLanguages: alternativeLanguages,
                                  activeLanguage: activeLanguage,
                                  close: close
                                }),
                            key: language.acronym
                          });
              })),
        display: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, displayLanguagesPanel),
        id: "languagesSwitcher",
        innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "None"),
        kind: /* List */5,
        ref_: ref,
        rules: Organism_Header_Css.LanguageSwitcher.rules,
        wrap: /* OnOneLine */1
      });
  var title = activeLanguage.title;
  var acronym = activeLanguage.acronym;
  var spacer = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeNone(undefined));
  var renderAcronymMobileButton = function (display) {
    return React.createElement(Atom_Cta.Button.make, {
                accessibility: Organism_HeaderAccessibility.accessibility(state),
                label: acronym,
                onClick: toggle,
                screenReadersLabel: title,
                style: {
                  TAG: /* Header */10,
                  _0: {
                    TAG: /* LanguageSwitcher */5,
                    _0: display,
                    _1: state
                  }
                }
              });
  };
  return React.createElement(Atom_Box.make, {
              background: Particle_Background_Ds.header,
              children: null,
              direction: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "column"),
              display: display,
              justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
              spacer: spacer,
              ref_: ref
            }, mode === "concert" && ffNewConcertHeader ? React.createElement(React.Fragment, undefined, React.createElement(Atom_Cta.Button.make, {
                        accessibility: Organism_HeaderAccessibility.accessibility(state),
                        display: Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "inlineFlex"),
                        onClick: toggle,
                        style: {
                          TAG: /* Header */10,
                          _0: {
                            TAG: /* Gear */3,
                            _0: state
                          }
                        }
                      }), renderAcronymMobileButton(Particle_Screen_Ds.make(undefined, undefined, "inlineFlex", "none", undefined, "none"))) : renderAcronymMobileButton(Particle_Screen_Ds.make(undefined, undefined, undefined, "none", undefined, "inlineFlex")), React.createElement(Atom_Cta.Button.make, {
                  accessibility: Organism_HeaderAccessibility.accessibility(state),
                  label: title,
                  onClick: toggle,
                  style: {
                    TAG: /* Header */10,
                    _0: {
                      TAG: /* LanguageSwitcher */5,
                      _0: Particle_Screen_Ds.make(undefined, undefined, undefined, "inlineFlex", undefined, "none"),
                      _1: state
                    }
                  }
                }), languagesPanel);
}

var make = Molecule_LanguageSwitcher;

exports.Item = Item;
exports.make = make;
/* CssJs Not a pure module */
